import React, { useState, useEffect } from "react";
import TopBarLogo from '../Shared/TopBarLogo';
import { getUserDetails } from "../../services/userServices";

export default function UserDetails() {
  const [userDetails, setUserDetails] = useState([]);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        if (!userDetails.length) {
          const userDetailsData = await getUserDetails();
          setUserDetails(userDetailsData);
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
        setUserDetails([]);
      }
    };

    fetchUserDetails();
  }, [userDetails.length]);

  return (
    <div>
      <TopBarLogo />
      <div className="info-box user-card">
        <h2 className="card-title">Información del usuario</h2>
        <div className="card-row">
          <span className="card-label">👤 Nombre:</span>
          <span className="card-value">{userDetails?.nombre}</span>
        </div>
        <div className="card-row">
          <span className="card-label">📧 Email:</span>
          <span className="card-value">{userDetails?.email}</span>
        </div>
        <div className="card-row">
          <span className="card-label">📱 Teléfono:</span>
          <span className="card-value">{userDetails?.telefono}</span>
        </div>
      </div>
    </div>
  );
}
